import Mi from '@mitchell/scss.magnetic';
import { Mitchell } from '@magnetic/tokens';
/**
 * Magnetic semantic variables. Read more about them here:
 * http://uxdesign.mitchell.com/magnetic-semantic-variables/
 */
export const Magnetic = Mi;
export const Mag = Mitchell;
//# sourceMappingURL=Semantic.js.map